import { Temporal } from '@js-temporal/polyfill'

export function getJoinUser(isoDate: string): string {
	const timeZone = 'America/Bogota'

	const instant = Temporal.Instant.from(isoDate)

	const joined = instant.toZonedDateTimeISO(timeZone)

	const now = Temporal.Now.zonedDateTimeISO(timeZone)

	const diff = now.since(joined, {
		largestUnit: 'months',
		smallestUnit: 'hours',
	})

	const rtf = new Intl.RelativeTimeFormat('es', { numeric: 'auto' })

	if (diff.hours < 24 && diff.days < 1) {
		return `Se unió ${rtf.format(-diff.hours, 'hour')}`
	} else if (diff.days < 7) {
		return `Se unió ${rtf.format(-diff.days, 'day')}`
	} else if (diff.days < 30) {
		const weeks = Math.floor(diff.days / 7)
		return `Se unió ${rtf.format(-weeks, 'week')}`
	} else {
		return `Se unió ${rtf.format(-diff.months, 'month')}`
	}
}
